import { toastMessage } from "./toastMessage";

export const regex = {
  email: /^(?=[a-zA-Z0-9@._%+-]{6,254}$)(?=[a-zA-Z0-9._%+-]{1,64}@)(?:(?!.*@.*@)[a-zA-Z0-9._%+-]+)@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
  url: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/,
  name: /^(?=.{3,})[a-zA-Z]+([ '-][a-zA-Z]+)*$/,
  imageFileRegex: /\.(jpg|jpeg|png|bmp|webp)$/i,
  ifscRegex: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  accountNumberRegex: /^\d{6,12}$/,
  documentFileRegex: /\.(pdf|doc|docx|txt)$/i,
  fileRegex: /\.(pdf|doc|docx|txt|jpg|jpeg|png|bmp|webp)$/i,
  pdfFileRegex: /\.(pdf)$/i,
  excelFileRegex: /\.(xlsx|xls)$/i,
  mobileRegex: /^\d{3,15}$/,

  audioFileRegex: /\.(mp3|wav|flac|m4a|aac|ogg)$/i,
  videoFileRegex: /\.(mp4|avi|mov|mkv|wmv|flv|webm)$/i,
  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%*~^&+=!]).{8,}$/,
  youtubeLinkRegex: /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\w+\/|(?:v|e(?:mbed)?)\/|\w+\/)?|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  facebookLinkRegex: /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:profile\.php\?id=\d+|[a-zA-Z0-9_.-]+)\/?/,
  twitterLinkRegex: /(?:https?:\/\/)?(?:www\.)?twitter\.com\/([A-Za-z0-9_]{1,15})\/?/,
  instagramLinkRegex: /(?:https?:\/\/)?(?:www\.)?instagram\.com\/([A-Za-z0-9_.]+)\/?/,
  linkedInLinkRegex: /(?:https?:\/\/)?(?:www\.)?linkedin\.com\/(in|pub|company|school)\/[A-Za-z0-9_-]+\/?/,
  extractYoutubeLink: /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  extractVimeoLink: /vimeo\.com\/(?:.*?\/)?(?:video\/)?([0-9]+)/,
  panRegex: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  gstRegex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
  aadharRegex: /^\d{12}$/,
};

export const tabHandler = (key, value, param, setParam) => {
  param.set(key, value);
  setParam(param);
};
//-----------remove-only-leading-space-----------
export const removeLeadingSpace = (value) => {
  return value.replace(/^\s+/, "")
}